import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, Text, MapWidget, MapMenu, MapItem, MapOverlay, MessageTooltip, MapTabs, MapTab, Image, MapLayer } from 'components/library'
import { Layer, Popup } from 'components/library/widgets/map/components'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import popupImg from './assets/Belijning_E3West_4@2x.jpg'
import layer2_4_1_3 from './assets/maplayer_2_4_1_3.svg'
import layer2_4_3 from './assets/maplayer_2_4_3-01.svg'

import './Aspect04.css'

class Aspect04 extends React.Component {

  render() {
    return (
      <div className="Chapter02-Aspect04">
        <PageContent nospacing>
          <ContentMenu
            menuOnTop
            activeHasBackground
            tabs={['Compenseerplaats', 'Kop 09']}>

            <ContentMenuTab>
              <MapWidget
                mapImage={mapBaseImage}
                mapBounds={[[0, 0], [3556, 3406]]}
                options={{ minZoom: -1.5 }}>

                <MapMenu>
                  <MapItem center={[2032,2600]} zoom={0.5}>
                    <MapOverlay>
                      <MessageTooltip>
                        <Text style={{ marginBottom: '2rem' }}>Op de compenseerplaats worden vliegtuigkompassen geijkt. Je vindt de compenseerplaats op rijbaan G3. Indien je van en naar de compenseerplaats moet slepen gelden de volgende regels:</Text>
                        <ul>
                          <li>Op de compenseerplaats wordt alleen gesleept, een vliegtuig mag hier niet zelf naartoe taxiën. Dit geldt ook voor (KLPD-)helikopters. Je mag dus alleen met een sleeptrekker inclusief sleepobject naar de compenseerplaats rijden.</li>
                          <li>Vanwege de beperkte verlichting wordt in principe alleen tijdens UDP naar de compenseerplaats. Indien je toch buiten UDP van of naar de compenseerplaats moet slepen krijg je begeleiding op rijbaan G3.</li>
                          <li>Voor het achteruit parkeren van een vliegtuig kun je hulp inroepen van een begeleider. Door de beperkte verlichting kan dit lastiger zijn.</li>
                        </ul>
                      </MessageTooltip>
                    </MapOverlay>
                  </MapItem>
                </MapMenu>
              </MapWidget>
            </ContentMenuTab>

            <ContentMenuTab>
              <MapWidget
                mapImage={mapBaseImage}
                mapBounds={[[0, 0], [3556, 3406]]}
                options={{ minZoom: -1.5 }}>

                <MapMenu>
                  <MapItem>
                    <MapOverlay>
                      <MessageTooltip>
                        <Text>Als je van of naar het Uniform-platform moet slepen, moet je voor Kop 09 langs kruisen. Hiervoor moet je toestemming krijgen van LVNL, ook als je zonder vliegtuig rijdt. Je meldt je op de verplichte meldpunten bij Apron Control:</Text>
                        <ul style={{ margin: '2rem 0'}}>
                          <li> Rijbaan A21 (richting het Uniform-platform).</li>
                          <li>Op rijbaan C en D voor rijbaan C3 (vanaf het Uniform-platform).</li>
                          <li>Meldpunt U (vanaf het Uniform-platform).</li>
                        </ul>
                        <Text>Apron Control zal je de opdracht geven over te schakelen naar LVNL. Bij LVNL doe je vervolgens de aanvraag om voor de kop langs te kruisen. Hoe je deze aanvraag doet leer je in Hoofdstuk 5.</Text>
                      </MessageTooltip>
                    </MapOverlay>
                    <MapLayer>
                      <Layer url={layer2_4_3} bounds={[[0,0],[3556, 3406]]} center={[2339,1159]} zoom={-0.84} />

                      <Popup position={[2606,622]} textCenter pinOnRight>
                        <Text><strong>Meldpunt</strong></Text>
                      </Popup>

                      <Popup position={[2285,591]} textCenter pinOnRight red>
                        <Text><strong>Kop 09</strong></Text>
                      </Popup>

                      <Popup position={[2204,803]} textCenter pinOnLeft>
                        <Text><strong>Meldpunt</strong></Text>
                      </Popup>

                      <Popup position={[2490,815]} textCenter pinOnLeft>
                        <Text><strong>Meldpunt</strong></Text>
                      </Popup>
                    </MapLayer>
                  </MapItem>
                </MapMenu>
              </MapWidget>
            </ContentMenuTab>

          </ContentMenu>
        </PageContent>
      </div>
    )
  }
}

export default Aspect04



// WEBPACK FOOTER //
// ./src/content/chapters/02/04/Aspect04.js